import { TFunction } from 'i18next'
import { z } from 'zod'

export const getAccountFromTemplateFormShape = (t: TFunction) => ({
  description: z.string(),
  name: z
    .string()
    .trim()
    .min(1, t('coa.account_from_base_form.new_account_name.error'))
    .max(255, t('coa.account_from_base_form.new_account_name.max_length_error')),
})
